import React, { useContext } from "react";
import { CurrentContext, SetterContext } from "../App";
import ConfigTextRadioButton from "./elements/ConfigTextRadioButton";

function TextButtonGroup( props: {
	fullwidth?: true,
	name: string;
	elements: string[],
	heading?: string,
	featureList?: any[],
	disableFirst?: number,
} ) {
	const Current = useContext( CurrentContext );
	const createSetter = useContext( SetterContext );

	if ( props.disableFirst ) {
		let marked = false;

		for ( let i = 0; i < props.elements.length; i++ ) {
			const element = props.elements[i];
			const isSelected = Current[props.name] === element;

			if ( isSelected && i < props.disableFirst ) {
				marked = true;
			}
		}

		if ( marked ) {
			createSetter( props.name )( props.elements[props.disableFirst] );
		}
	}


	return <div className="flex category-container" id="fahrzeug-laenge">
		{props.heading && <div className="flex category-title">{props.heading}</div>}
		<div className="flex button-area" id="fahrzeug-laenge-buttons">
			{props.elements.map(
				( v, index ) =>
					<ConfigTextRadioButton
						fullwidth={props.fullwidth}
						value={v}
						key={v}
						name={props.name}
						disabled={!!( props.disableFirst && props.disableFirst > index )}
						selected={Current[props.name] === v}
						callback={createSetter( props.name )}
					/>,
			)}
		</div>
		{props.featureList && <>
			<div className="flex vertical-line"></div>
			<div className="flex paket-content" id="fahrzeug-paket-inhalt">
				{props.featureList[props.elements.indexOf( Current[props.name] )]}
			</div>
		</>}
	</div>;
}

export default TextButtonGroup;
